import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledBreadcrumbs = styled('nav')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_14}
    ${({ theme }: { theme: Theme }) => `
        /* stylelint-disable unit-allowed-list */
        box-sizing: content-box;
        max-width: ${theme.tggSpacing(rem(128), 320)};
        padding: ${theme.tggSpacing([rem(2), rem(3), 0], [5, 7.5, 0])};
        margin: ${theme.tggSpacing([0, 'auto', rem(3)], [0, 'auto', 7.5])};

        `}
`;

export const StyledList = styled('ol')`
    ${({ theme }: { theme: Theme }) => `
        padding-left: ${theme.tggSpacing(0, 0)};
        margin: ${theme.tggSpacing(0, 0)};
        line-height: 2rem;
        list-style: none;
    `}
`;
export const StyledListItem = styled('li')`
    ${({ theme }: { theme: Theme }) => `
            display: inline;

        + li::before {
            display: inline-block;
            margin: ${theme.tggSpacing([0, rem(1)], [0, 2.5])};
            font-size: inherit;
            color: ${theme.palette.primary.main};
            content: '/';
        }

        a {
            color: ${theme.palette.common.blue};
            text-decoration: none;
        }
	`}
`;
